interface Props {
  current: number;
  total: number;
}

export function ProgressDots({ current, total }: Props) {
  return (
    <div className="flex items-center gap-1.5 pt-16 px-7">
      {Array.from({ length: total }).map((_, i) => (
        <div
          key={i}
          className={`h-1 rounded-full transition-all duration-300 ${
            i === current ? 'w-6 bg-accent' : 'w-2 bg-surface-raised'
          } ${i < current ? 'bg-accent' : ''}`}
        />
      ))}
    </div>
  );
}
